// import React, { useState } from "react";
// import { Customstyles } from "../components/styles/Customstyles";

// export const CustomstyleModel = ({ onApply, onClose }) => {

//     const stylesList = Object.keys(Customstyles).map((key) => ({
//         id: key,
//         label: Customstyles[key].name,
//         description: Customstyles[key].description,
//         before: Customstyles[key].beforeImage || "",
//         after: Customstyles[key].afterImage || "",
//     }));

//     const [selectedStyle, setSelectedStyle] = useState(stylesList[0]?.id || null);
//     const [selectAll, setSelectAll] = useState(false);
//     const [searchTerm, setSearchTerm] = useState("");

//     const [selectedStyles, setSelectedStyles] = useState(
//         stylesList.reduce((acc, style) => {
//             acc[style.id] = false;
//             return acc;
//         }, {})
//     );

//     const handleSelectAll = () => {
//         const newSelectAll = !selectAll;
//         setSelectAll(newSelectAll);

//         const updated = {};
//         stylesList.forEach((style) => {
//             updated[style.id] = newSelectAll;
//         });

//         setSelectedStyles(updated);
//     };

//     const handleCheckboxChange = (id) => {
//         const updated = {
//             ...selectedStyles,
//             [id]: !selectedStyles[id],
//         };

//         setSelectedStyles(updated);

//         setSelectAll(Object.values(updated).every((val) => val));
//     };

//     const filteredStyles = stylesList.filter((style) =>
//         style.label.toLowerCase().includes(searchTerm.toLowerCase())
//     );

//     // SUBMIT
//     const handleApply = () => {

//         const selectedArray = Object.keys(selectedStyles).filter(
//             (key) => selectedStyles[key]
//         );

//         if (onApply) {
//             onApply(selectedArray);
//         }

//         if (onClose) {
//             onClose();
//         }
//     };

//     const selectedStyleData = stylesList.find(
//         (style) => style.id === selectedStyle
//     );

//     return (
//         <div className="customstyle w-full h-full flex flex-col">

//             {/* Search + Select All */}
//             <div className="w-full flex flex-col p-2 gap-4">

//                 <div className="flex items-center gap-2">
//                     <span className="font-medium text-[15px]">Select All</span>
//                     <input
//                         type="checkbox"
//                         className="w-[14px] h-[14px] cursor-pointer"
//                         checked={selectAll}
//                         onChange={handleSelectAll}
//                     />
//                 </div>

//                 <div className="relative w-full flex items-center">

//                     <span className="absolute left-3 text-gray-400 flex items-center"> <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" > <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-4.35-4.35m1.35-5.15a7 7 0 11-14 0 7 7 0 0114 0z" /> </svg> </span>

//                     <input
//                         type="search"
//                         placeholder="Search styles..."
//                         className="w-full pl-9 pr-8 py-2 border border-gray-300 rounded-md outline-none focus:ring-2 focus:ring-blue-400"
//                         value={searchTerm}
//                         onChange={(e) => setSearchTerm(e.target.value)}
//                     />

//                 </div>

//             </div>

//             {/* Styles + Preview */}
//             <div className="flex flex-1 overflow-hidden">

//                 {/* LEFT PANEL */}
//                 <div className="w-1/3 flex flex-col gap-2 overflow-y-auto p-2 border-r border-gray-200">

//                     {filteredStyles.map((style) => (

//                         <div
//                             key={style.id}
//                             className={`p-2 cursor-pointer rounded hover:bg-gray-100 ${selectedStyle === style.id ? "bg-blue-50" : ""
//                                 }`}
//                             onClick={() => setSelectedStyle(style.id)}
//                         >

//                             <div className="flex items-center gap-2">

//                                 <input
//                                     type="checkbox"
//                                     className="w-[14px] h-[14px] cursor-pointer"
//                                     checked={selectedStyles[style.id]}
//                                     onChange={() => handleCheckboxChange(style.id)}
//                                     onClick={(e) => e.stopPropagation()}
//                                 />

//                                 <span>{style.label}</span>

//                             </div>

//                         </div>

//                     ))}

//                 </div>

//                 {/* RIGHT PANEL */}
//                 <div className="w-2/3 p-4 overflow-y-auto">

//                     {selectedStyleData && (

//                         <>
//                             <h3 className="font-medium text-lg mb-2">
//                                 {selectedStyleData.label}
//                             </h3>

//                             <p className="mb-4">
//                                 {selectedStyleData.description}
//                             </p>

//                             <div className="mb-4">
//                                 <h4 className="font-medium mb-2">Before</h4>

//                                 {selectedStyleData.before && (
//                                     <img
//                                         src={selectedStyleData.before}
//                                         alt="Before"
//                                         className="border rounded"
//                                     />
//                                 )}
//                             </div>

//                             <div>
//                                 <h4 className="font-medium mb-2">After</h4>

//                                 {selectedStyleData.after && (
//                                     <img
//                                         src={selectedStyleData.after}
//                                         alt="After"
//                                         className="border rounded"
//                                     />
//                                 )}
//                             </div>

//                         </>
//                     )}

//                 </div>

//             </div>

//             {/* FOOTER */}
//             <div className="p-4 border-t border-gray-200 flex justify-end gap-4">

//                 <button
//                     className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300"
//                     onClick={onClose}
//                 >
//                     Close
//                 </button>

//                 <button
//                     className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
//                     onClick={handleApply}
//                 >
//                     Submit
//                 </button>

//             </div>

//         </div>
//     );
// };


// CustomstyleModel.jsx
// CustomstyleModel.jsx
// CustomstyleModel.jsx
// CustomstyleModel.jsx
import React, { useState, useEffect } from "react";
import { Checkbox, Input, Button } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { Customstyles } from "../components/styles/Customstyles";

export const CustomstyleModel = ({ onApply, onClose, editor }) => {
  // Move all hooks to the top level, before any conditional returns
  const [selectedStyles, setSelectedStyles] = useState({});
  const [selectAll, setSelectAll] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [activeStyle, setActiveStyle] = useState(null);

  const stylesList = Object.entries(Customstyles).map(([key, style]) => ({
    id: style.id || key,
    label: style.name,
    description: style.description,
    beforeImage: style.beforeImage,
    afterImage: style.afterImage
  }));

  // Initialize selected styles
  useEffect(() => {
    const initialSelected = {};

    stylesList.forEach((style, index) => {
      initialSelected[style.id] = index === 0;
    });

    setSelectedStyles(initialSelected);

    if (stylesList.length > 0) {
      setActiveStyle(stylesList[0]);
    }

  }, []);

  // Only show loading message if editor is not available
  if (!editor) {
    return (
      <div className="p-4 text-center">
        <p>Editor not available. Please try again.</p>
      </div>
    );
  }

  const handleSelectAll = () => {
    const newSelectAll = !selectAll;
    setSelectAll(newSelectAll);

    const updated = {};
    stylesList.forEach(style => {
      updated[style.id] = newSelectAll;
    });

    setSelectedStyles(updated);
  };

  const handleCheckboxChange = (id) => {
    const updated = {
      ...selectedStyles,
      [id]: !selectedStyles[id]
    };

    setSelectedStyles(updated);
    setSelectAll(Object.values(updated).every(val => val));
  };

  const filteredStyles = stylesList.filter(style =>
    style.label.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleApply = () => {
    const selectedArray = Object.entries(selectedStyles)
      .filter(([_, isSelected]) => isSelected)
      .map(([id]) => id);

    if (onApply) {
      onApply(selectedArray);
    }

    if (onClose) {
      onClose();
    }
  };

  return (
    <div className="customstyle-modal w-full h-full flex flex-col overflow-hidden">
      <div className="w-full flex flex-col pl-0 p-4 gap-4 ">
        <div className="flex items-center gap-2">

          <Checkbox
            checked={selectAll}
            onChange={handleSelectAll}
          />
          <span className="font-medium">Select All</span>
        </div>

        <Input
          placeholder="Search styles..."
          prefix={<SearchOutlined />}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="custom-search"
        />
      </div>

      <div className="flex flex-1 overflow-hidden">
        <div className="w-1/3 flex flex-col gap-2 overflow-y-auto pl-0 p-4 border-r">
          {filteredStyles.map(style => (
            <div
              key={style.id}
              className={`p-2 cursor-pointer rounded hover:bg-gray-100 ${selectedStyles[style.id] || activeStyle?.id === style.id ? "bg-blue-50 border border-blue-200" : ""
                }`}
              onClick={() => setActiveStyle(style)}
            >
              <div className="flex items-center gap-2">
                <Checkbox
                  checked={selectedStyles[style.id] || false}
                  onChange={() => handleCheckboxChange(style.id)}
                  onClick={e => e.stopPropagation()}
                />
                <span>{style.label}</span>
              </div>
            </div>
          ))}
        </div>

        <div className="w-2/3 p-4 overflow-y-auto">
          {activeStyle && (
            <>
              <div className="flex gap-2 ">
                <p className=" mt-1"><strong>Name: </strong></p>
                <h3 className="font-medium text-lg mb-2">
                  {activeStyle.label}
                </h3>
              </div>

              <div className="flex gap-2 ">
                <p><strong>Descriptions: </strong></p>
                <p className="mb-4 text-gray-600">
                  {activeStyle.description}
                </p>
              </div>

              <div className="mt-4 p-3 bg-blue-50 ">
                <p><strong>Before: </strong></p>
                <img src={process.env.PUBLIC_URL + activeStyle.beforeImage} alt="before-img" />
                <p><strong>After: </strong>-</p>
                <img src={process.env.PUBLIC_URL + activeStyle.afterImage} alt="after-img" />
              </div>
            </>
          )}
        </div>
      </div>

      <div className="p-4  flex justify-end gap-4">
        <Button onClick={onClose} className="custom-orange-btn-secondary">
          Close
        </Button>
        <Button
          onClick={handleApply}
          disabled={Object.values(selectedStyles).every(val => !val)}
          className="bg-[#F44F0D] text-white hover:bg-[#d9440c] disabled:bg-gray-300 disabled:text-gray-500 custom-orange-btn-primary"
        >
          Apply Styles
        </Button>
      </div>
    </div>
  );
};







